__turbopack_context__.v({
  "chevron": "PeriodFilter-module__LuTYVW__chevron",
  "item": "PeriodFilter-module__LuTYVW__item",
  "itemActive": "PeriodFilter-module__LuTYVW__itemActive",
  "list": "PeriodFilter-module__LuTYVW__list",
  "popoverContent": "PeriodFilter-module__LuTYVW__popoverContent",
  "popoverRoot": "PeriodFilter-module__LuTYVW__popoverRoot",
  "range": "PeriodFilter-module__LuTYVW__range",
  "trigger": "PeriodFilter-module__LuTYVW__trigger",
  "triggerActive": "PeriodFilter-module__LuTYVW__triggerActive",
  "triggerLabel": "PeriodFilter-module__LuTYVW__triggerLabel",
  "triggerWrapper": "PeriodFilter-module__LuTYVW__triggerWrapper",
});
